<template>
  <div class="text-item-wrap">
    <div class="text-label-wrap">
      <span class="text-label">{{ label }}</span>
    </div>
    <div v-if="values && values.length" class="text-field-container">
      <TextBox :value="hanldeValueItem" isHtml :overLineClamp="values.length > 1" textLineClamp />
    </div>

    <c-nodata v-else></c-nodata>
  </div>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from '../monTarget.mixin.js';
import TextBox from '@/containers/popup/components/TextBoxV2.vue';

export default {
  name: 'TextItems',
  mixins: [i18nMixin, monTargetMixin],
  components: {
    TextBox
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    values: {
      type: Array,
      default: () => {}
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      monSchema: {}
    };
  },
  created() {
    this.setLabel();
  },
  mounted() {},
  methods: {
    setLabel() {
      this.monSchema = _.cloneDeep(this.labelField);
    }
  },
  computed: {
    hanldeValueItem() {
      return this.values
        .map((item) => {
          if (typeof item === 'string') return this.$util.escapeHTML(item);
          else if (typeof item === 'object') return this.$util.escapeHTML(item.value);
        })
        .join('</br>');
    }
  }
};
</script>

<style lang="scss" scoped>
.text-item-wrap {
  position: relative;
  font-family: $lego__font-family !important;

  .text-label-wrap {
    width: 180px;
    height: 16px;

    .text-label {
      display: inline-block;
      width: 180px;
      font-family: $lego__font-family;
      font-size: 14px;
      line-height: 16px;
      color: #2e3138;
      font-weight: 700;
    }
  }
  .text-field-container {
    padding: 8px 0 0 0;

    ::v-deep .text-field-wrap {
      padding: 0 !important;
    }
  }
}
</style>
